import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Mail, Shield } from 'lucide-react';
import './Services.css';
import Logo from "../assets/hyderotrace.svg";
import img1 from "../assets/img-1.png";
import groundWater from "../assets/videos/ground-water.mp4";
import naturalRainfall from "../assets/videos/natural-rainfall.mp4";
import rainEnhancement from "../assets/videos/rain-enhancement.mp4";
import surfaceWater from "../assets/videos/surface-water.mp4";
import unifiedIntelligence from "../assets/videos/unified-intelligence.mp4";
import climatology from "../assets/videos/climatology.mp4";
export const Services = ({ setView }) => {
    // Static demo user data (since no authentication required for this page)
    const demoUser = {
        fullname: 'Guest User',
        email: 'guest@hydrotrace.com',
        role: 'Visitor',
        tenant_id: 'DEMO-001'
    };

    const services = [
        {
            title: 'Ground Water',
            description: 'Subsurface Flow & Aquifer Status',
            videoUrl: groundWater,
            thumbnail: ''
        },
        {
            title: 'Surface Water',
            description: 'Reservoir Levels & River Monitoring',
            videoUrl: surfaceWater,
            thumbnail: ''
        },

        {
            title: 'Natural Rainfall',
            description: 'Real-time Precipitation',
            videoUrl: naturalRainfall,
            thumbnail: ''
        },

        {
            title: 'Rain Enhancement',
            description: 'Cloud Intelligence & Cloud Seeding',
            videoUrl: rainEnhancement,
            thumbnail: ''
        },
        {
            title: 'Climatology ',
            description: 'Extreme Weather Forecast',
            videoUrl: climatology,
            thumbnail: ''
        },
        {
            title: 'Unified Intelligence',
            description: 'AI-driven Analytics & Predictive Modeling',
            videoUrl: unifiedIntelligence,
            thumbnail: ''
        }
    ];

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #000B07 0%, #000B07 100%)',
                padding: '20px',
                color: '#fff'
            }}
        >
            {/* Header - Dashboard Style */}
            <div class="inner-header" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '40px',
                borderBottom: '1px solid #333',
                paddingBottom: '20px'
            }}>
                <div>
                    {/* <h1 style={{ margin: '0 0 8px 0', fontSize: '28px', fontWeight: '600' }}>
                        HydroTRACE Services
                    </h1>
                    <p style={{ margin: 0, color: '#888', fontSize: '14px' }}>
                        Explore our comprehensive water management solutions
                    </p> */}
                    <img src={Logo} alt="Logo" className='innerlogo' />
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    {/* User Info Badge */}
                    {/* <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '8px 16px',
                        background: 'rgba(59, 130, 246, 0.1)',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        borderRadius: '6px'
                    }}>
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px',
                            fontWeight: '600'
                        }}>
                            {demoUser.fullname.charAt(0).toUpperCase()}
                        </div>
                        <div>
                            <div style={{ fontSize: '14px', fontWeight: '500' }}>{demoUser.fullname}</div>
                            <div style={{ fontSize: '12px', color: '#888' }}>{demoUser.role}</div>
                        </div>
                    </div>

                    <button
                        onClick={() => setView('signin')}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
                            color: 'white',
                            border: 'none',
                            padding: '10px 16px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(59, 130, 246, 0.4)';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        <ArrowLeft size={18} />
                        Back to Login
                    </button> */}
                    <img src={img1} alt="Logo" className='img1' />
                </div>
            </div>

            {/* User Info Cards Section */}
            {/* <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '20px',
                marginBottom: '40px'
            }}>
               
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    style={{
                        background: 'linear-gradient(135deg, #1e293b 0%, #2d3748 100%)',
                        border: '1px solid #333',
                        borderRadius: '8px',
                        padding: '24px',
                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '12px',
                            fontSize: '20px',
                            fontWeight: '600'
                        }}>
                            {demoUser.fullname.charAt(0).toUpperCase()}
                        </div>
                        <div>
                            <h3 style={{ margin: '0', fontSize: '16px', fontWeight: '600' }}>
                                {demoUser.fullname}
                            </h3>
                            <p style={{ margin: '4px 0 0 0', color: '#888', fontSize: '12px' }}>
                                Tenant ID: {demoUser.tenant_id}
                            </p>
                        </div>
                    </div>
                    <div style={{ borderTop: '1px solid #333', paddingTop: '12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontSize: '13px' }}>
                            <Mail size={14} style={{ color: '#3b82f6' }} />
                            <span>{demoUser.email}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' }}>
                            <Shield size={14} style={{ color: '#3b82f6' }} />
                            <span>Role: <strong>{demoUser.role}</strong></span>
                        </div>
                    </div>
                </motion.div>

               
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    style={{
                        background: 'linear-gradient(135deg, #1e293b 0%, #2d3748 100%)',
                        border: '1px solid #333',
                        borderRadius: '8px',
                        padding: '24px',
                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
                    }}
                >
                    <h3 style={{ margin: '0 0 12px 0', fontSize: '16px', fontWeight: '600' }}>
                        Public Access
                    </h3>
                    <p style={{ margin: '0', color: '#888', fontSize: '13px', lineHeight: '1.6' }}>
                        This is a public services page. You can explore all our features without logging in.
                        Sign up to access the full dashboard and start managing your water resources.
                    </p>
                </motion.div>
            </div> */}

            {/* Services Grid */}
            <div style={{ marginBottom: '40px' }}>
                <h2 style={{
                    fontSize: '24px',
                    fontWeight: '600',
                    marginBottom: '24px',
                    textAlign: 'left'
                }}>
                    Modules
                </h2>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                    gap: '24px'
                }}>
                    {services.map((service, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.1 * index }}
                            className='modules-box-bg'

                            whileHover={{ y: -8 }}
                        >
                            <div>
                                <div className='modules-heading-bg'>
                                    <h3 style={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        margin: '0 0 16px 0',
                                        color: '#fff'
                                    }}>
                                        {service.title}
                                    </h3>
                                    <p style={{
                                        fontSize: '14px',
                                        color: '#94a3b8',
                                        lineHeight: '1.6',
                                        margin: '0'
                                    }}>
                                        {service.description}
                                    </p>
                                </div>

                                <div style={{
                                    width: '100%',
                                    marginBottom: '16px',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    background: '#000'
                                }}>
                                    <video
                                        autoPlay
                                        loop
                                        muted

                                        poster={service.thumbnail}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            display: 'block',
                                            maxHeight: '250px',
                                            objectFit: 'cover'
                                        }}
                                        preload="metadata"
                                    >
                                        <source src={service.videoUrl} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>


                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Footer - Dashboard Style */}
            <div style={{
                marginTop: '40px',
                paddingTop: '20px',
                borderTop: '1px solid #333',
                textAlign: 'center',
                color: '#666',
                fontSize: '12px'
            }}>
                <p>© 2025 Accel1 Inc. All rights reserved     |     www.accel1.com</p>

            </div>
        </motion.div>
    );
};

export default Services;
